'use strict';

const BookerPresenter = require('../presenters/booker');
const BaseView = require('./base');
const BookView = require('./book');
const DatePickerView = require('./datepicker');
const InfoView = require('./info');
const PickersView = require('./pickers');
const QuantityPickerView = require('./quantitypicker');
const SeatingInfoView = require('./seatingInfo');
const SectionSelectorView = require('./sectionSelector');
const SectionMapView = require('./sectionMap');
const TimePickerView = require('./timepicker');
const ContinueButtonView = require('./continueButton');

class SeatingBookerView extends BaseView {
  constructor() {
    super(...arguments);

    this.selectDate = this.selectDate.bind(this);
    this.selectTime = this.selectTime.bind(this);
    this.selectQuantity = this.selectQuantity.bind(this);
    this.selectSection = this.selectSection.bind(this);
    this.on('renderComplete', this.afterRender);
    this.on('sectionMapRendered', this.renderSectionSelectorView);
    this.model.on('updatedCollections', this.renderInfo, this);
    this.model.on('updatedCollections', this.renderSubmitSection, this);
    this.model.on('updatedCollections', this.enableClearButton, this);
    this.model.on('updatedCollections', this.displayCaptcha, this);
    this.model.on('change:shouldShowSeating', this.render, this);
    this.model.on('change:isSectionMapZoomedIn', this.renderSectionMap, this);
    this.model.on('change:selectedSection', this.sectionChangeHandler, this);
    this.model.on('clearAll', this.disableClearButton, this);
  }

  initialize() {
    this.popstateHandlerRef = this.popstateHandler.bind(this);
    window.addEventListener('popstate', this.popstateHandlerRef);

    this.setModule('glive_booking_redesign');
    this.presenter = BookerPresenter;
  }

  className() {
    return 'glive_booking_redesign-component';
  }

  events() {
    return {
      'submit form': 'book',
      'click #continue-button': 'showSeating',
      'click #change-booking': 'hideSeating',
      'click .open .btn': 'open',
      'click .icon-close': 'close',
      'click #zoom-in': 'zoomSectionMap',
      'click #zoom-out': 'unzoomSectionMap',
    };
  }

  book(event) {
    window.removeEventListener('click', this.sectionsBackButtonHandlerRef, true);
    window.removeEventListener('popstate', this.popstateHandlerRef);
    this.showSpinner();
    event.stopPropagation();
    this.model.book();
    return false;
  }

  showSeating(event) {
    this.sectionsBackButtonHandlerRef = this.sectionsBackButtonHandler.bind(this);
    window.addEventListener('click', this.sectionsBackButtonHandlerRef, { capture: true, once: true });

    event.stopPropagation();
    if (!this.shouldShowSeating()) {
      this.model.toggleShowSeating();
    }
    return false;
  }

  popstateHandler(event) {
    // User comes from the deal page to the pickers
    if ($('#glive-booking-pane').css('display') === 'none') {
      this.clearAll();
      return;
    }

    // User comes from the seating to the pickers
    if (this.shouldShowSeating()) {
      this.hideSeating(event);
      history.go(1);
      return;
    }
  }

  sectionsBackButtonHandler(event) {
    // This condition ensures that this event only happens when we are on the section selector
    if (event.target.className === 't-back-link' && this.shouldShowSeating()) {
      this.hideSeating(event);
    }
  }

  hideSeating(event) {
    event.stopPropagation();
    if (this.shouldShowSeating()) {
      this.model.toggleShowSeating();
      this.clearAll();
    }
    return false;
  }

  zoomSectionMap() {
    if (!this.model.get('isSectionMapZoomedIn')) {
      this.model.toggleIsSectionMapZoomedIn();
    }
    this.sectionMapView.zoomSectionMapWrapper();
    return false;
  }

  unzoomSectionMap() {
    if (this.model.get('isSectionMapZoomedIn')) {
      this.model.toggleIsSectionMapZoomedIn();
    }
    this.sectionMapView && this.sectionMapView.unzoomSectionMapWrapper();
    return false;
  }

  clearAll() {
    this.unzoomSectionMap();
    return this.model.clearAll();
  }

  selectDate(date) {
    return this.model.selectDate(date);
  }

  selectTime(time) {
    return this.model.selectTime(time);
  }

  selectQuantity(quantity) {
    return this.model.selectQuantity(quantity);
  }

  selectSection(section) {
    return this.model.selectSection(section);
  }

  renderSubmitSection() {
    const initHash = { model: this.model };

    this.buttonView = this.shouldShowSeating() ? new BookView(initHash) : new ContinueButtonView(initHash);

    const buttonContainer = this.$el.find('[data-submit-section-content]');
    if (buttonContainer.length) {
      buttonContainer.html(this.buttonView.render().el);
    }
    this.$('#reservation-loader').hide();

    if (this.model.shouldShowCaptcha() && this.shouldShowSeating()) {
      this.resizeCaptcha();
    }
  }

  showSpinner() {
    //TODO: add/remove classes for continue button as well/instead
    if (this.model.showSpinner()) {
      $('#book-now-button').addClass('loading');
      $('#book-now-button').removeClass('c-txt-white');
    }
  }

  setOpen() {
    if (this.options.overlapWith) {
      $(this.options.overlapWith).hide();
    }
    this.options.isOpen = true;
    return this.options.isOpen;
  }

  setOpenAndLocked() {
    this.setOpen();
    this.options.isLocked = true;
    return this.options.isLocked;
  }

  open() {
    this.setOpen();
    this.model.reset();
    this.render({ fadeIn: true });
  }

  close() {
    this.options.isOpen = false;
    return this.$el.fadeOut(() => {
      this.render();
      if (this.options.overlapWith) {
        $(this.options.overlapWith).fadeIn();
      }
      return this.model.resetOption();
    });
  }

  render() {
    // hide initially so that the showMethod can fade in at the end of the render method
    this.$el.hide();
    super.render(...arguments);
    if (!this.model.get('error')) {
      if (this.options.isOpen) {
        this.$el.find('[data-info-content]').hide();
        if (this.model.get('isSellable')) {
          this.renderInfo();
          this.renderSubmitSection();
          if (!this.shouldShowSeating()) {
            this.renderPickers();
            this.renderClearButton();
          } else {
            this.renderCaptcha();
          }
        }
      }
    }
    const showMethod = (arguments[0] != null ? arguments[0].fadeIn : undefined) === true ? 'fadeIn' : 'show';
    this.$el[showMethod]();
    this.options.isOpen && this.trigger('renderComplete'); // triggers afterRender() method for SectionSelectorView
    return this;
  }

  afterRender() {
    // all other elements must be rendered and visible before calculating
    // height of sectionMap and sectionSelectorView
    if (this.shouldShowSeating()) {
      this.renderSectionMap();
      this.trigger('sectionMapRendered'); // triggers renderSeatSelectorView
    }
  }

  renderInfo() {
    if (this.shouldShowSeating()) {
      this.infoView = new SeatingInfoView({ model: this.model });
    } else {
      this.infoView = new InfoView({ model: this.model });
    }

    const infoContainer = this.$el.find('[data-glive-info-content]');
    infoContainer.html(this.infoView.render().el);
    return this.infoView;
  }

  sectionChangeHandler() {
    this.sectionMapView && this.sectionMapView.resetOriginalImageSizeModel();
    this.renderSectionMap();
  }

  renderSectionMap() {
    if (!this.model.get('shouldShowSeating')) {
      return false;
    }
    this.initializeSectionMapView().render();
    return this.sectionMapView;
  }

  initializeSectionMapView() {
    this.sectionMapView = new SectionMapView({
      el: this.$el.find('[data-map-display-content]'),
      model: this.model,
    });
    const maxMapHeight = this.getMaxMapHeight();
    const appWidth = $('#deal-booker').width();
    // use booking widget's width or the maxMapHeight - whichever is smaller
    const mapHeight = Math.min(maxMapHeight, appWidth);
    this.sectionMapView.$el.css({ height: mapHeight });

    return this.sectionMapView;
  }

  getFormHeight() {
    const bodyHeight = $('body').innerHeight();
    // This is 0 when standalone and 48 when loaded from deal page
    const headerHeight = parseFloat($('div#deal-booker').css('padding-top'));
    const infoSectionHeight = $('.glive-booking-info').outerHeight();
    const submitSectionHeight = parseFloat($('div.book.sticky-footer').outerHeight());

    return bodyHeight - (headerHeight + infoSectionHeight + submitSectionHeight);
  }

  getMaxMapHeight() {
    const formHeight = this.getFormHeight();
    const sectionSelectorMinHeight = 132;
    return formHeight - sectionSelectorMinHeight;
  }

  renderSectionSelectorView() {
    if (!this.shouldShowSeating()) {
      return;
    }
    this.initializeSectionSelectorView().render();
  }

  initializeSectionSelectorView() {
    this.sectionSelectorView = new SectionSelectorView({
      el: this.$el.find('[data-section-selector-content]'),
      model: this.model,
      collection: this.model.get('sections'),
      selectionName: 'selectedSection',
    });
    const sectionSelectorHeight = this.getSectionSelectorHeight();
    this.sectionSelectorView.$el.css({ 'max-height': sectionSelectorHeight || '' });

    return this.sectionSelectorView;
  }

  getSectionSelectorHeight() {
    const formHeight = this.getFormHeight();
    const mapDisplayHeight = this.$el.find('.map').outerHeight();
    return formHeight - mapDisplayHeight;
  }

  renderPickers() {
    this.initializePickersView();
    this.pickersView.render();
    this.pickersView.once('expanded', () => this.trigger('ready')); // Is anything listening for this event?
  }

  initializePickersView() {
    this.pickersView = new PickersView({
      el: this.$el.find('[data-pickers-content]'),
    });

    this.datePicker = this.pickersView.add({
      view: DatePickerView,
      model: this.model,
      collection: 'dates',
      selectionName: 'selectedDate',
      handleSelect: this.selectDate,
    });

    this.timePicker = this.pickersView.add({
      view: TimePickerView,
      model: this.model,
      collection: 'times',
      selectionName: 'selectedTime',
      handleSelect: this.selectTime,
    });

    this.quantityPicker = this.pickersView.add({
      view: QuantityPickerView,
      model: this.model,
      collection: 'quantities',
      selectionName: 'selectedQuantity',
      handleSelect: this.selectQuantity,
    });

    return this.pickersView;
  }

  getPickersContainer() {
    return this.$el.find('[data-pickers-content]');
  }

  getBookNowContainer() {
    return this.$el.find('#submit-section');
  }

  renderClearButton() {
    // this method must fire after renderPickersContainer
    const pickersContainer = this.getPickersContainer();
    pickersContainer.append(
      '<div class="clear-button" data-bhw="GliveBookingDealBookerClearAll" >Clear All Selections</div>'
    );
    $('.clear-button').click(() => {
      this.clearAll();
    });
  }

  enableClearButton() {
    $('.clear-button').addClass('clear-enabled');
    $('.clear-button').addClass('c-txt-prim');
  }

  disableClearButton() {
    $('.clear-button').removeClass('clear-enabled');
    $('.clear-button').removeClass('c-txt-prim');
    this.pickersView.postRender();
  }

  renderCaptcha() {
    if (!this.model.get('requiresCaptcha')) {
      return;
    }
    const siteKey = this.model.get('captchaSiteKey');
    const bookNowContainer = this.getBookNowContainer();
    const renderCallback = () => {
      this.renderBookButton();
    };

    $(window).resize(this.resizeCaptcha);
    window.recaptchaOnLoad = () => {
      window.grecaptcha.render('glive-recaptcha', {
        callback: renderCallback,
        'expired-callback': renderCallback,
        sitekey: siteKey,
      });
      this.resizeCaptcha();
    };

    const recaptchaJsUrl = this.model.get('recaptchaJsUrl');
    bookNowContainer.append($('<script async defer>').attr('src', recaptchaJsUrl));
  }

  resizeCaptcha() {
    const $grecaptchaDiv = $('#glive-recaptcha');
    if (!$grecaptchaDiv.children()[0]) {
      return;
    }

    const recaptchaMinWidth = 314;
    const scaleRatio = Math.min(recaptchaMinWidth, $grecaptchaDiv.width()) / $grecaptchaDiv.children().width();
    $grecaptchaDiv.children().css({ transform: `scale(${scaleRatio})` });
    if (this.model.shouldShowCaptcha()) {
      const scaledPadding = Math.ceil(Math.max(0, scaleRatio - 1) * 7);
      const padding = `${7 + scaledPadding}px 0 ${10 + scaledPadding}px`;
      $grecaptchaDiv.css({ padding });
    }
  }

  displayCaptcha() {
    if (this.model.shouldShowCaptcha()) {
      $('#glive-recaptcha').addClass('show');
    } else {
      $('#glive-recaptcha').removeClass('show');
    }

    this.resizeCaptcha();
  }

  shouldShowSeating() {
    return !!this.model.get('shouldShowSeating');
  }
}

module.exports = SeatingBookerView;
